module.exports = __webpack_public_path__ + "img/error@2x.3077cc69.png";